// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"ef8852f8","374":"262aa98b","384":"049871d8","480":"66f7a283","521":"f4256f34","641":"b44f338e","732":"dcec090b","816":"0a28fc99","835":"3078d4b1","859":"cbe4ae75","939":"9ca2691c","966":"2e511ffc","998":"f4dc6453"}[chunkId] + ".chunk.js";
};